module.exports = "{{t \"activeVoucher\"}}"